/** Time-of-day greeting key, read from the viewer's own device clock (the
 * one timezone signal available without a server round trip). */
export const greetingKeyForHour = (hour: number): "morning" | "afternoon" | "evening" => {
  if (hour < 12) return "morning"
  if (hour < 18) return "afternoon"
  return "evening"
}

export const currentGreetingKey = (): "morning" | "afternoon" | "evening" =>
  greetingKeyForHour(new Date().getHours())
